




































































import { Component, Mixins } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { toDateStringSafe } from '@/helpers/date'
import Axios from 'axios'
import { IPlaylistWithTracks } from '@/classes/playlist'
import { IColumnDef } from '@/interfaces/ag-grid'
import { HistoryViewMixin, LibraryMixin } from '@/mixins'
import { TrackFields } from '@/constants'
import { ITutorialSlide } from '@/components/Tutorial.vue'

enum VIEWS {
  Start = 'start',
  Tracks = 'tracks'
}

enum REORDER_TABLE_STATES {
  Idle = 'idle',
  ShowTrackPlaylistOccurrence = 'track_playlist_occurrence',
  ShowDuplicateTracksInPlaylist = 'duplicate_tracks_in_playlist'
}

@Component({
  components: {
    Card: require('@/components/Card').default,
    TrackPlaylistOccurrence: require('./TrackPlaylistOccurrence').default,
    ReorderTable: require('@/components/ReorderTable').default,
    DuplicateTracksInPlaylists: require('./DuplicateTracksInPlaylists').default,
    Tutorial: require('@/components/Tutorial').default,
    PlaylistSaveModal: require('@/components/PlaylistSaveModal').default,
    CopyTextModal: require('@/components/CopyTextModal').default
  }
})
export default class HealthCheck extends Mixins(HistoryViewMixin, LibraryMixin) {
  loading: boolean = false
  view: VIEWS = VIEWS.Start
  tracks: Track[] = []
  playlistWithTracks: IPlaylistWithTracks
  reorderTableNextLabel: string = ''
  reorderTableState: REORDER_TABLE_STATES = REORDER_TABLE_STATES.Idle
  reorderTableLoading: boolean = false
  text: string = ''

  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.Title
    },
    {
      field: TrackFields.Artist
    }
  ]

  tutorialSlides: ITutorialSlide[] = [
    {
      html: `Health Checks scan your library for specific problems and help you fix them in the way you want to fix them.<br><br>In this tutorial, I'm going to show you how powerful Health Checks can be.`
    },
    {
      image: 'healthchecks1.png',
      html: `The first Health Check I'm running is the <strong>Duplicate Track Scanner</strong> in the Companion App.<br><br>After the scan is complete, I'm presented with a list of tracks that are found to have identical audio. In the first result, I'm telling rekordcloud to keep one file and delete the other. Any playlist referring to the second file, is updated and changed to the first file.<br><br>In the second result, I told rekordcloud to keep the AIFF file, but to use the cues from the WAV file. The WAV file will be deleted, playlists will be updated and the AIFF file will have the cue points.<br><br>It's not just going to delete your files, you'll get a chance to review and confirm before deleting anything.`
    },
    {
      image: 'healthchecks2.png',
      html: `Now I've run the <strong>Broken Track Scanner</strong> in the Companion App. The list of tracks I'm shown are either missing or could not be played. Rekordcloud scans the integrity of every file in your library, this is really good to do once in a while. You don't want to be surprised with corrupt files while you're performing.<br><br>I can let rekordcloud delete these files now or I can save these files in a text file. That way I have a list of tracks that I should replace.`
    },
    {
      image: 'healthchecks3.png',
      html: `The <strong>Unused File Scanner</strong> works very similar to the last scanner that I've shown. It will show you files that are in your music folders but not in use by your library (text files, images, other non-audio files). Really useful to do some good cleaning. In my library here, I can already save almost 1GB of space just from covert art and useless files alone.<br><br>That's the end of the tutorial. Health Checks are very useful tools to keep your library clean and running them once in a while can give you confidence that your library is in good order.`
    }
  ]

  get playlistsAmount(): number {
    return this.$store.getters['library/playlists'].length
  }

  get suggestedPlaylistName(): string {
    return `Tracks in playlist ${toDateStringSafe(new Date())}`
  }

  setText(t: string) {
    this.text = t
  }

  showTrackPlaylistOccurrence() {
    this.reorderTableNextLabel = ''
    this.reorderTableState = REORDER_TABLE_STATES.ShowTrackPlaylistOccurrence
    this.goToView(VIEWS.Tracks)
  }

  showDuplicateTracksInPlaylist(pl: IPlaylistWithTracks) {
    this.playlistWithTracks = pl

    this.reorderTableNextLabel = 'Remove duplicates'
    this.reorderTableState = REORDER_TABLE_STATES.ShowDuplicateTracksInPlaylist
    this.goToView(VIEWS.Tracks)
  }

  async reorderTableNext() {
    if (this.reorderTableState === REORDER_TABLE_STATES.ShowTrackPlaylistOccurrence) {
      throw new Error('should not reach this state anymore: ' + this.reorderTableState)
    } else if (this.reorderTableState === REORDER_TABLE_STATES.ShowDuplicateTracksInPlaylist) {
      this.reorderTableLoading = true

      try {
        await Axios.post('/playlist/remove-duplicates', {
          id: this.playlistWithTracks._id,
          trackIds: this.tracks.map(x => x._id)
        })

        await this.$store.dispatch('library/fetchLibrary')

        this.$buefy.notification.open(`Removed duplicates from ${this.playlistWithTracks.name}`)
      } catch (error) {
        console.error(error)

        if (this.$store.state.auth.isDemoUser) {
          this.$buefy.notification.open('Removed duplicates from playlist')
        }
      }

      this.reorderTableLoading = false

      this.view = VIEWS.Start
      this.reorderTableState = REORDER_TABLE_STATES.Idle
    }
  }
}
